import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "vip-tab" }
const _hoisted_3 = { style: {"margin":"10px 0"} }
const _hoisted_4 = { class: "history-active" }
const _hoisted_5 = { class: "activeColor" }

import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { ref, reactive, onMounted,nextTick } from 'vue';
import { getVipHistory, getVipAiHistory, getvipInfo } from "@/api/common.js"
import { ElMessage } from 'element-plus'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'purchaseHistoryDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const store = useStore();
const props = __props
const dialogShow = ref(props.popupShow)
const purchaseType = ref('vip')
const numObj = ref({ aiNum: 0, vipAiNum: 0 })
const emitList = __emit

const tableList = ref([] as any)
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 0
})
const pageShow=ref(true)

function closeEvent() {
    emitList('close')
}

function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}

function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value=false;
    getList()
    nextTick(()=>{
        pageShow.value=true;
    })
}

function purchaseTypeChange() {
    tableList.value = []
    pageInfo.value.total = 0;
    handleCurrentChange(1)
}

function typeFormat(row) {
    switch (row.type) {
        case 1:
            return '后台充值';
        case 2:
            return '线上充值';
        case 3:
            return '消耗';
        default:
            return row.type
    }
}

function getNum() {
    getvipInfo().then(res => {
        numObj.value = res.data || { aiCallRestNum: 0, vipRestNum: 0 }
    })
}
function getList() {
    const params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size
    }
    const api = purchaseType.value == 'vip' ? getVipHistory : getVipAiHistory;
    api(params).then(res => {
        tableList.value = res.data.records || []
        pageInfo.value.total = res.data.total || 0;
    })
}

onMounted(() => {
    getNum()
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogShow).value = $event)),
    width: "80%",
    title: "VIP与AI次数明细记录",
    center: "",
    onClose: closeEvent,
    "append-to-body": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_radio_group, {
            modelValue: purchaseType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((purchaseType).value = $event)),
            fill: "#ef8b25",
            onChange: purchaseTypeChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, {
                label: "VIP购买明细记录",
                value: "vip"
              }),
              _createVNode(_component_el_radio_button, {
                label: "AI次数明细记录",
                value: "ai"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createTextVNode("剩余： ")),
            _createElementVNode("span", _hoisted_5, _toDisplayString(numObj.value[`${purchaseType.value=='ai'?'aiCallRestNum':'vipRestNum'}`]) + _toDisplayString(purchaseType.value=='ai'?'次':'天'), 1)
          ]),
          _createVNode(_component_el_table, {
            data: tableList.value,
            style: {"width":"100%"},
            border: "",
            maxHeight: "38vh"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "memberName",
                label: "明细记录",
                width: "180"
              }),
              _createVNode(_component_el_table_column, {
                prop: "type",
                label: "方式"
              }),
              (purchaseType.value=='vip')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    prop: "days",
                    label: "天数(次)"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_text, { type: "success" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.days), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (purchaseType.value=='ai')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    prop: "memberAiTimes",
                    label: "次数(次)"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_text, {
                        type: scope.row.type=='消耗'?'warning':'success'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.times), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                prop: "createTime",
                label: "时间"
              })
            ]),
            _: 1
          }, 8, ["data"]),
          (pageShow.value)
            ? (_openBlock(), _createBlock(_component_el_config_provider, {
                key: 0,
                locale: _unref(zhCn)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_pagination, {
                    style: {"margin-top":"10px"},
                    "current-page": pageInfo.value.current,
                    "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageInfo.value.current) = $event)),
                    "page-size": pageInfo.value.size,
                    "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageInfo.value.size) = $event)),
                    "page-sizes": [10, 20, 30, 50],
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: pageInfo.value.total,
                    onSizeChange: handleSizeChange,
                    onCurrentChange: handleCurrentChange
                  }, null, 8, ["current-page", "page-size", "total"])
                ]),
                _: 1
              }, 8, ["locale"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})